"use client";
import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
const Accordion = (props: any) => {
  const {
    title,
    subtitle1,
    subtitle2,
    subtitle3,
    description,
    isFullBorder,
    downloadLink,
    isDownload,
    isPDF,
    isTeam,
    isArchive,
    cls,
  } = props;
  const [open, setOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(true);
  const [isDownloadHovered, setIsDownloadHovered] = useState(true);
  return (
    <div className={`${!open ? "xl:h-[130px] h-auto" : "mb-6"}`}>
      <div
        className={`overflow-hidden group ${
          description?.length > 0 ? "cursor-pointer" : ""
        }  ${
          isFullBorder
            ? `border-black border-2  ${
                open
                  ? "border-2"
                  : `${
                      description?.length > 0
                        ? "xl:hover:shadow-accordion xl:hover:shadow-black"
                        : ""
                    }`
              } border-solid `
            : ` border-b-2 border-black ${
                open
                  ? "border-b-2"
                  : `${description?.length > 0 ? "xl:hover:border-b-4" : ""}`
              } `
        }`}
      >
        <div
          className="relative"
          onClick={description?.length > 0 ? () => setOpen(!open) : undefined}
        >
          <div
            className={`flex justify-between items-center ${
              isFullBorder ? "p-[15px]" : "p-[20px] pb-2.5 pl-0"
            }`}
          >
            <div className="flex flex-col w-[80%]">
              <h5
                className={`w-[125%] ${
                  description?.length > 0
                    ? "cursor-pointer xl:hover:underline accordion-header"
                    : ""
                } ${isTeam ? "h-[40px]" : ""}`}
                onClick={
                  description?.length > 0 ? () => setOpen(!open) : undefined
                }
              >
                {title}
              </h5>
              <div className={`${isArchive ? "flex w-[120%] md:w-full" : ""}`}>
                <p
                  className="bdy-txt-2"
                  onClick={
                    description?.length > 0 ? () => setOpen(!open) : undefined
                  }
                >
                  {subtitle1}{" "}
                </p>
                {subtitle2 && (
                  <span className={`${isArchive ? "block pr-1" : "hidden"}`}>
                    ,
                  </span>
                )}
                <p className={`${isArchive ? "bdy-txt-2" : "bdy-txt-3"}`}>
                  {subtitle2}
                </p>
              </div>
              {subtitle3 && <p className="bdy-txt-3">{subtitle3}</p>}
            </div>
            <div
              className={`actions flex flex-row absolute right-0 md:bottom-[10px] bottom-[5px] ${
                isFullBorder ? `` : `${cls}`
              }${isPDF ? `mr-[5px]` : ``}${
                open ? " absolute right-0 bottom-0 pb-[5px] " : ""
              }`}
            >
              <div
                className={`signs ${isPDF ? "mr-4" : "mr-[5px]"} ${
                  description?.length > 0 ? "block" : "hidden"
                }`}
                onClick={
                  description?.length > 0 ? () => setOpen(!open) : undefined
                }
              >
                {open ? (
                  <div
                    onMouseEnter={() => setIsHovered(false)}
                    onMouseLeave={() => setIsHovered(true)}
                    onClick={() => setIsHovered((prevValue) => !prevValue)}
                  >
                    {isHovered ? (
                      <Image
                        src="/assets/icons/collapse-green.svg"
                        alt="Green"
                        width={30}
                        height={30}
                        className="cursor-pointer"
                      />
                    ) : (
                      <Image
                        src="/assets/icons/collapse-black.svg"
                        alt="Green"
                        width={30}
                        height={30}
                        className="cursor-pointer"
                      />
                    )}
                  </div>
                ) : (
                  <div
                    onMouseEnter={() => setIsHovered(false)}
                    onMouseLeave={() => setIsHovered(true)}
                  >
                    {isHovered ? (
                      <Image
                        src="/assets/icons/expand-green.svg"
                        alt="Green"
                        width={30}
                        height={30}
                        className="cursor-pointer"
                      />
                    ) : (
                      <Image
                        src="/assets/icons/expand-black.svg"
                        alt="Green"
                        width={30}
                        height={30}
                        className="cursor-pointer"
                      />
                    )}
                  </div>
                )}
              </div>
              {isPDF && (
                <div className="download">
                  <div
                    onMouseEnter={() => setIsDownloadHovered(false)}
                    onMouseLeave={() => setIsDownloadHovered(true)}
                    onClick={() =>
                      setIsDownloadHovered((prevValue) => !prevValue)
                    }
                  >
                    <Link
                      href={downloadLink || ""}
                      target="_blank"
                      download={downloadLink}
                    >
                      {isDownloadHovered ? (
                        <Image
                          src="/assets/icons/download-green.svg"
                          alt="Green"
                          width={30}
                          height={30}
                          className="cursor-pointer"
                        />
                      ) : (
                        <Image
                          src="/assets/icons/download-black.svg"
                          alt="Green"
                          width={30}
                          height={30}
                          className="cursor-pointer"
                        />
                      )}
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div
            className={`transition-all duration-300 pt-0 pb-[30px] xl:pb-[15px] ${
              open ? "block" : "hidden"
            } ${isFullBorder ? "p-[15px]" : "pb-[20px]"}`}
          >
            <p className="bdy-txt-2 w-[95%] pb-[15px] leading-8">
              {description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Accordion };
